import React, { useCallback, useRef, useState } from 'react';
import cx from 'classnames';

import useIntersectionObserver, { useSupportsIntersectionObserver } from 'Utilities/hooks/useIntersectionObserver';

import type { StraplineProps } from './Strapline.types';

import styles from './Strapline.module.scss';

const STAT_DELAY = 0.2;

const Strapline: React.FC<StraplineProps> = ({ stats }) => {
	const [shouldShowStats, setShouldShowStats] = useState(false);
	const containerRef = useRef<HTMLUListElement>(null);

	const onIntersect = useCallback(
		(entries: IntersectionObserverEntry[]) => {
			const { isIntersecting } = entries[0];
			if (!shouldShowStats && isIntersecting) {
				setShouldShowStats(true);
			}
		},
		[shouldShowStats],
	);

	const supportsIntersectionObserver = useSupportsIntersectionObserver({
		defaultValue: true,
	});

	// @ts-expect-error - no types for useIntersectionObserver
	useIntersectionObserver({ onIntersect, target: containerRef, threshold: 0.1 });

	return (
		<section>
			<ul
				ref={containerRef}
				className={cx(styles.stats, {
					[styles.show]: !supportsIntersectionObserver || !!shouldShowStats,
				})}
				data-testid="strapline"
			>
				{stats.map((stat, index) => (
					<li
						key={stat.primary}
						className={styles.stat}
						style={{
							transitionDelay: `${index * STAT_DELAY}s`,
						}}
					>
						<strong className={styles.primary}>{stat.primary}</strong>
						{stat.secondary}
					</li>
				))}
			</ul>
		</section>
	);
};

export default Strapline;
